
<template>
  <div>
    <v-row class="ma-0 py-1 px-3 grey lighten-3" style="border-radius: 9px;" >
      <div class="title">Produto {{idx != null ? idx+1 : 'novo'}}</div>
      <v-spacer></v-spacer>
      <v-btn v-if="can_delete" icon color="error" @click="removeItem"><v-icon>mdi-delete</v-icon></v-btn>
    </v-row>
    <v-container class="pt-2">
      <v-row class="pt-3">
        <v-col cols="12" md="6" :class="[$vuetify.breakpoint.smAndDown ? 'pb-0 pt-0' : '']"> 
          <v-select
            v-model="item.brand_id"
            :items="brands"
            item-text="name"
            item-value="id"
            :loading="loading_brands"
            :readonly="loading_brands"
            label="Marca"
            :rules="[...required]"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" :class="[$vuetify.breakpoint.smAndDown ? 'pb-0 pt-0' : '']"> 
          <v-select
            v-model="item.segment_id"
            :disabled="!item.brand_id"
            :items="segments"
            item-text="name"
            item-value="id"
            :loading="loading_segments"
            :readonly="loading_segments"
            label="Segmento"
            :rules="[...required]"
          ></v-select>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-select
            v-model="item.stock_id"
            :items="products_segmented"
            :disabled="!item.brand_id && !item.segment_id"
            item-text="product.name"
            item-value="id"
            :loading="loading_products"
            :readonly="loading_products"
            label="Produto"
            :rules="[...required]"
          ></v-select>
        </v-col>
        <v-col cols="12" class="pa-0">
        </v-col>
      </v-row>

      <v-row v-if="has_last_order && last_items_data" class="px-3 mt-0">
        <div>
          Dados do último pedido:
        </div>
        <v-col cols='12' class="pt-2">
          <v-row>
            <div class="mr-2">
              <b>Unidades:</b> {{last_items_data.total_units}}
            </div>
            <div class="mr-2">
              <b>Venda und.:</b> {{Number(last_items_data.sell_price).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
            </div>
          </v-row>
        </v-col>
      </v-row>

      <v-row align="start" justify="space-between">
        <v-col cols='12' sm='4' class="pb-0 pt-1" align="center">
          <v-text-field v-model="item.total_units_aux" prepend-icon="mdi-information" label="Unidades" v-currency="currency" :rules="not_zero"></v-text-field>
        </v-col>
        <v-col cols='12' sm='4' class="pb-0 pt-1" align="center">
          <v-skeleton-loader v-if="!price_ready" type="list-item"></v-skeleton-loader>
          <v-text-field v-if="price_ready" v-model="item.sell_price_aux" prepend-icon="mdi-currency-usd" prefix='R$' label="Venda und." v-currency="currency" :rules="not_zero"></v-text-field>
        </v-col>
        <v-col cols='12' sm='4' class="pb-0 pt-1" align="center">
          <div class="caption">Venda</div>
          <span class="title">Total: {{ item_total_price.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'} ) }} </span>
        </v-col>
      </v-row>

      <v-row align="start" justify="space-between" v-if="order.kind == 'delivery'">
        <v-col cols='12' sm='4' class="py-0" align="center">
          <!-- <v-text-field v-model="item.total_units_aux" prepend-icon="mdi-information" label="Unidades" v-currency="currency" :rules="not_zero"></v-text-field> -->
        </v-col>
        <v-col cols='12' sm='4' class="py-0" align="center">
          <v-text-field v-model="item.unit_ship_aux" prepend-icon="mdi-currency-usd" prefix='R$' label="Frete und." v-currency="currency" :rules="not_zero"></v-text-field>
        </v-col>
        <v-col cols='12' sm='4' class="py-0" align="center">
          <div class="caption">Frete</div>
          <span class="title">Total: {{ item_total_ship.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'} ) }} </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'
import validations from '@/mixins/validations'
import {CurrencyDirective} from 'vue-currency-input'

export default {
  name: 'ProductsOneItem',
  props: {
    item: {
      type: Object,
    },
    idx: {
      type: Number,
    },
    can_delete: {
      type: Boolean,
      default: true,
    },
    order:{
      type: Object
    }
  },
  mixins: [validations],
  directives: {
    currency: CurrencyDirective,
  },
  data() {
    return {
      key: null,
      brands: [],
      loading_brands: false,
      segments: [],
      loading_segments: false,
      products: [],
      loading_products: false,
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },
      price_ready: true,

      client_last_order: null
    }
  },
  methods: {
    removeItem() {
      this.$emit('removeItem', this.idx)
    },
    getSegments(brand_id = null){
      this.loading_segments = true
      this.segments = []
      let filter = {
        brand_id,
      }
      Api.Supplier.indexSegment(filter).then(r=>r.data).then(seg => {
        seg = seg.data? seg.data.map(seg=> seg.attributes) : seg
        this.segments = [...seg]
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_segments = false
      })
    },
    getBrands(){
      this.loading_brands = true
      Api.Supplier.indexBrand({only_brands: true}).then(r=>r.data).then(b => {
        b = b.data? b.data.map(bd=> bd.attributes) : b
        this.brands = [...b]
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_brands = false
      })
    },
    getProducts({model, id}){
      this.loading_products = true
      const ACTION = model? 'indexProductByModel' : 'indexProduct'
      Api.Supplier[ACTION]({model, id}).then(r=>r.data).then(p => {
        p = p.data? p.data.map(pd=> pd.attributes) : p
        this.products = [...p]
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_products = false
      })
    },
    getProductsFromStock({model, id, brand_id}){
      this.loading_products = true
      const ACTION = model? 'indexByModelHttpRetail' : 'indexHttpRetail'
      Api.Stock[ACTION]({model, id, brand_id, params: {only_positive_stocks: true}}).then(r=>r.data).then(p => {
        p = p.data? p.data.map(pd=> pd.attributes) : p
        this.products = [...p]
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading_products = false
      })
    },
    reloadPriceValue(val){
      this.item.sell_price_aux = val || '0.00'
      this.price_ready = false
      setTimeout(() => {
        this.price_ready = true
      }, 500);
    },
    prepareToGetClientLastOrder(){
      let data = {
        client_id: this.order.client_id,
        product_id: this.order.items_attributes.map(it=> it.product_id),
        segment_id: this.order.items_attributes.map(it=> it.segment_id),
        brand_id: this.order.items_attributes.map(it=> it.brand_id),
        modality_id: this.order.modality_id,
      }
      if (!this.order.is_default_client){
        this.getClientLastOrder(data)
      }
    },

    getClientLastOrder(data){
      Api.Client.showClientLastOrder(data).then(response => response.data).then(order => {
        this.client_last_order = order
        this.$emit('clientLastOrder', order)
      }).catch(error => {
        console.log(error)
      }).finally(()=>{
        
      })
    },

  },
  mounted () {
    this.getBrands();
    if (this.item.product_id) {
      this.getSegments(this.item.brand_id)
      this.getProductsFromStock({model: 'modalities', id: this.order.modality_id, brand_id: this.item.brand_id})
    }

    const product_not_in_segment = !this.products_segmented.some(el=>el.product_id == this.item.product_id)

    if (product_not_in_segment) {
      this.item.product_id = null
      this.item.stock_id = null
    }
  },
  computed: {
    has_last_order(){
      return !!this.client_last_order
    },
    last_items_data(){
      if (this.has_last_order){
        let it = this.client_last_order.items.find(({brand_id, product_id, segment_id})=> brand_id==this.item.brand_id && product_id==this.item.product_id && segment_id==this.item.segment_id)
        return it
      }
      return null
    },
    is_order_delivery(){
      return this.order.kind == 'delivery'
    },
    products_segmented(){
      if (this.products.length && this.item.segment_id){
        return this.products.filter(p=> ((p.segment && p.segment.id == this.item.segment_id)))
      }
      return []
    },
    item_total_price() {
      let total = 0
      if (this.item.total_units && this.item.sell_price){
        total = Number(this.item.total_units_aux.replace(/,/g, '')) * Number(this.item.sell_price_aux.replace(/,/g, ''))
        this.item.total_sell_price = total
      }
      return total
    },
    item_total_ship() {
      let total = 0
      if (this.item.total_units && this.item.unit_ship){
        total = Number(this.item.total_units_aux.replace(/,/g, '')) * Number(this.item.unit_ship_aux.replace(/,/g, ''))
        this.item.total_ship = total
      }
      return total
    },
  },
  watch: {
    'item.brand_id'(nv) {
      if (nv) {
        this.getSegments(nv)
        this.item.brand_name = this.brands.find(b => Number(b.id) == Number(nv)).name
        this.item.product_id = null
        this.item.stock_id = null
        this.item.segment_id = null
      }
    },
    'item.segment_id'(nv) {
      if (nv) {
        this.item.segment_name = this.segments.find(b => Number(b.id) == Number(nv)).name
        this.getProductsFromStock({model: 'modalities', id: (this.order.modality_id || this.activeModalityId), brand_id: this.item.brand_id})
        this.item.product_id = null
        this.item.stock_id = null
      }
    },

    'item.stock_id'(nv) {
      if (nv) {
        this.item.product_id = this.products.find(p => Number(p.id) == Number(nv)).product.id
      } else {
        this.reloadPriceValue()
      }
    },
    
    'item.product_id'(nv) {
      if (nv) {
        this.item.product_name = this.products.find(p => Number(p.product_id) == Number(nv)).product.name
        this.reloadPriceValue(this.products.find(p => Number(p.product_id) == Number(nv)).sell_price)
        this.prepareToGetClientLastOrder()
      } else {
        this.reloadPriceValue()
      }
    }
  },
}
</script>

<style scoped>

</style>
